
            const data = {"name":"close","data":{"viewBox":"0 0 32 32","data":"<path pid=\"0\" d=\"M26.2 6.4l-.8-.8-9.5 9.6-9.5-9.6-.8.8 9.6 9.5-9.6 9.5.8.8 9.5-9.6 9.5 9.6.8-.8-9.6-9.5z\"/>"}}
        
                module.exports = data
                